<bruit-io
  [config]="bruitConfig"
  [data]="getBruitData()"
  (onError)="handleBruitError($event)"
  class="fixed bottom-0 right-0 mr-3 mb-2"
  matTooltip="Remonter un bug"
></bruit-io>
